import { render } from "./AddClassifiPage.vue?vue&type=template&id=12fb04e6"
import script from "./AddClassifiPage.vue?vue&type=script&lang=js"
export * from "./AddClassifiPage.vue?vue&type=script&lang=js"

import "./AddClassifiPage.vue?vue&type=style&index=0&id=12fb04e6&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__